import {Component, OnInit} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {DataService, DatasetBannerModel, DatasetBannerView} from 'src/app/services/data.service';
import {SessionService, UserType} from 'src/app/services/session.service';

@Component({
  selector: 'app-vendor-ask-ai',
  templateUrl: './ask-ai.component.html',
  styleUrls: ['./ask-ai.component.scss']
})
export class AskAiComponent implements OnInit {

  enterpriseUser = null;
  aiUrl = null;

  constructor(private sessionService: SessionService,
              public dataservice: DataService,
              public datasetBannerModel: DatasetBannerModel,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    if (this.dataservice.data.accountId === this.sessionService.getUser().roleId) {
      this.enterpriseUser = true;
    } else {
      this.enterpriseUser = false;
    }
    this.aiUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.datasetBannerModel.dataset.askAiUrl);
    this.datasetBannerModel.setBannerView(DatasetBannerView.AIView);
  }
}
